module.exports = __webpack_public_path__ + "static/media/icon_node_js.c502658a.png";